import React from 'react'
import {connect} from 'react-redux'
import {Distance, Elevation, Speed, Duration} from 'common/units'
import moment from 'moment'
import {urls} from 'lib/urls'
import {TripThumb} from 'common/ListItems'
import {HighlightedPhoto} from 'common/ListItems/HighlightedPhoto'
import {Icon} from 'common/Icon'
import cx from 'classnames'
import styles from './RideCondensedStats.scss'
import {DELETE_TROUTE_DIALOG} from 'common/dialogs/DeleteTRoute'
import {j} from 'lib/textUtils'
import {readDateFormatFromPreferences} from 'lib/dateUtils'
import {MobileCollapse} from 'common/layouts/SideNavLayout/SideNavContexts'
import {tripSelectors} from 'data/resources/trips'

export class _RideCondensedStats extends React.PureComponent {
  onArrowClick = () => this.props.toggleItem(this.props.expandKey)

  render () {
    const {trip, expanded, expandKey, showDialog, currentUser, checkbox} = this.props
    const isExpanded = expanded.has(expandKey)

    return (
      <div className={cx(styles.RideCondensedStats, isExpanded && styles.isExpanded)}>
        <Grid className={styles.mainGrid}>
          <MobileCollapse>{checkbox}</MobileCollapse>
          <Col className={styles.nameAndLocationCol} flex='7'>
            <h4><a href={urls.trips.show(trip.id)} title={trip.name}>{trip.name}</a></h4>
            <div className={styles.location}>
              <span data-tip title='Start Location'>
                {j([trip.locality, trip.administrativeArea])}
              </span>
            </div>
          </Col>
          <Col className={styles.rideStatsCol} flex={3 * 6}>
            <RideStats trip={trip} currentUser={currentUser} />
          </Col>
          <Col className={styles.actionsCol} flex='0 0 auto' alignRight>
            <div className={styles.actionsIcons}>
              <a href={`/trips/${trip.id}/edit`}>
                <Icon
                  className={styles.actionsIcon}
                  data-tip
                  title='Edit'
                  i='md-create'
                  size={20} />
              </a>
              <Icon
                onClick={() => showDialog(DELETE_TROUTE_DIALOG)}
                data-tip
                title='Delete'
                i='md-trash'
                size={20}
                className={styles.actionsIcon} />
            </div>
          </Col>
          <Col className={styles.thumbnailsCol} flex='0 0 92px' alignRight>
            <HighlightedPhoto photoId={trip.highlightedPhotoId} parentType={'trip'} parentId={trip.id} readonly={false} style={{height: '40px', width: '40px'}} />
            <TripThumb size={40} trip={trip} />
          </Col>
          <MobileCollapse>
            <Col className={styles.expandIconCol} flex='0 0 auto' alignRight>
              <div className={styles.expandClickTarget} onClick={this.onArrowClick}>
                <Icon i={'ios-arrow-down'} size={22} className={cx(styles.expandIcon, isExpanded && styles.expanded)} />
              </div>
            </Col>
          </MobileCollapse>
        </Grid>
      </div>
    )
  }
}

const RideStats = ({trip, currentUser}) => (
  <div className={styles.RideStats}>
    <Grid className={styles.statGrid}>
      <Col>
        <span data-tip title='Distance'>
          <Distance short value={trip.distance} />
        </span>
      </Col>
      <Col>
        <span data-tip title='Elevation Gain'>
          <Elevation short value={trip.elevationGain} />
        </span>
      </Col>
      <Col>
        <span data-tip title='Moving Time (hh:mm)'>
          {typeof trip.movingTime === 'string' || trip.movingTime === null
            ? trip.movingTime
            : <Duration value={trip.movingTime} valueOnly bigUnits />}
        </span>
      </Col>
      <Col>
        <span data-tip title='Avg Speed'>
          {trip.avgSpeed && <Speed short value={trip.avgSpeed} />}
        </span>
      </Col>
      <Col>
        {trip.avgWatts
          ? <span data-tip title='Avg Power'>{Math.round(trip.avgWatts)} watts</span>
          : <span data-tip title='Avg Power (estimated)'><em>{Math.round(trip.avgPowerEstimated)} watts</em></span>}
      </Col>
      <Col>
        {trip.visibility === 1 && 'Private'}
        {trip.visibility === 2 && 'Friends Only'}
        {!trip.visibility && 'Public'}
      </Col>
    </Grid>
    <Grid className={styles.dateGrid}>
      <Col className={styles.dateCol} flex={undefined}>
        {moment(trip.departedAt).format(readDateFormatFromPreferences())}
      </Col>
    </Grid>
  </div>
)

const Grid = ({className, children}) => (
  <div className={cx(styles.Grid, className)}>
    {children}
  </div>
)

const Col = ({children, className, flex, alignRight, marginTop}) => {
  const margin = `${marginTop} 0 0 0` || ''
  return <div className={cx(styles.Col, className, alignRight && styles.alignRight)} style={{flex: flex, margin: margin}}>
    {children}
  </div>
}

const mapStateToProps = (state, ownProps) => {
  return {
    trip: tripSelectors.find(state, ownProps.troute.id)
  }
}

export const RideCondensedStats = connect(
  mapStateToProps,
  null
)(_RideCondensedStats)
